export default __webpack_public_path__ + "static/media/leaves-white.737ee751.svg";